import { catalogItemReducerPath } from './const';
import { CatalogItemViewReducerStateShape } from './types';

export const catalogItemSelector = (state: CatalogItemViewReducerStateShape) => state[catalogItemReducerPath];
